import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import './StageChangeModal.css'
import { IoMdClose } from "react-icons/io";
import { Check2Circle } from "react-bootstrap-icons";
import axios from "axios";
import { toast } from "react-toastify";
import CustomDropdown from "../Dropdown/Dropdown";
import StageTransitionDropdown from "../StageTransitionDropdown/StageTransitionDropdown";

const StageChangeModal = ({
    onClose,
    obj,
    setObj,
    handleSubmit
}) => {

    const [allowedStages, setAllowedStages] = useState([]);

    // Get auth token
    const authToken = useMemo(() => {
        const tokens = JSON.parse(sessionStorage.getItem("tokens")) || null;
        return tokens?.token || null;
    }, []);

    let headers = {
        Authorization: `Bearer ${authToken}`,
        'Content-type': 'application/json'
    }

    const getAllowedStages = async (obj) => {
        console.log({ obj });
        try {
            let resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/applications/${obj?.application_id}/${obj?.transition_level}/allowed-stage-transitions`, {
                headers
            });

            setAllowedStages(resp?.data?.data);

            // console.log({ data: resp?.data?.data });
        } catch (error) {
            toast.error(`${error?.response?.data?.message}`);
        }
    }

    useEffect(() => {
        getAllowedStages(obj);
    }, []);

    return (
        <div className="stage-change-modal-overlay" onClick={onClose}>
            <div className="stage-change-modal-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="stage-change-modal-content">
                    <div className="stage-change-modal-header">
                        <div>
                            <h5 className="stage-change-modal-title">Confirm Stage Change</h5>
                            <span className="stage-change-modal-subtitle">Review the stage transition details before confirming</span>
                        </div>
                        <button onClick={onClose} className="btn-close">
                            <IoMdClose size={24} />
                        </button>
                    </div>

                    <div className="stage-change-modal-body">
                        {/* Application Info */}
                        <div className="application-info">
                            Change stage for Application{" "}
                            <strong>{obj.application_id}</strong>
                        </div>

                        {/* Allowed Stages Info */}
                        {/* <div className="application-info">
                            <StageTransitionDropdown
                                value={obj?.new_child_stage}
                                options={allowedStages.map(stage => ({
                                    parentStage: stage.target_parent_stage_name,
                                    childStage: stage.target_child_stage_name,
                                    prerequisites: stage.satisfied_prerequisites
                                }))}
                                onChange={(selected) => {
                                    setObj(prev => ({
                                        ...prev,
                                        new_child_stage: selected.childStage,
                                        new_parent_stage: selected.parentStage,
                                        satisfied_prerequisites: selected.prerequisites
                                    }));
                                }}
                            />
                        </div> */}

                        {/* From → To */}
                        <div className="stage-transition">
                            <span className="stage-pill from">
                                Current application stage: {obj.previous_stage}
                            </span>
                            {/* <span className="stage-pill from">
                                From: {obj.previous_stage}
                            </span>

                            <span className="arrow">→</span>

                            <span className="stage-pill to">
                                To: {obj?.transition_level === "CHILD" ? obj?.new_child_stage : obj?.new_parent_stage}
                            </span> */}
                        </div>

                        {/* Prerequisites Box */}
                        {/* {obj?.satisfied_prerequisites?.length > 0 && (
                            <div className="prereq-box">
                                <h6>Prerequisites passed</h6>
                                <ul>
                                    {obj?.satisfied_prerequisites?.map((item, index) => (
                                        <li key={index}>
                                            <span className="check-icon">
                                                <Check2Circle />
                                            </span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )} */}

                        {/* Reason Input */}
                        <div className="reason-section">
                            <label>Reason for manual stage change</label>

                            <textarea
                                name="reason"
                                value={obj?.reason}
                                onChange={(e) => setObj(prev => ({
                                    ...prev,
                                    reason: e.target.value
                                }))}
                                placeholder="Enter reason for this stage change..."
                            />
                        </div>
                    </div>

                    <div className="stage-change-modal-footer">
                        <button
                            onClick={onClose}
                            className="stage-change-btn btn-outline"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => {
                                handleSubmit(obj)
                            }}
                            className="stage-change-btn btn-solid"
                        >
                            Confirm & Change Stage
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StageChangeModal;